// src/modules/notifications/container/type.ts

export const NotificationTypes = {
  INotificationService: Symbol("INotificationService"),
};
